var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4032_246521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8385 6.52333C17.606 6.20672 17.3023 5.94916 16.952 5.77141C16.6018 5.59366 16.2146 5.50069 15.8218 5.5H4.17847C3.78566 5.50069 3.39851 5.59366 3.04822 5.77141C2.69793 5.94916 2.3943 6.20672 2.1618 6.52333L0.455968 8.85083C0.0970256 9.33903 -0.0718495 9.94123 -0.0190916 10.5449C0.0336663 11.1485 0.304446 11.7123 0.742635 12.1308L10.0001 20.4425L19.2885 12.1025C19.7157 11.6826 19.9768 11.1225 20.0238 10.5253C20.0708 9.92814 19.9005 9.33409 19.5443 8.8525L17.8385 6.52333ZM6.09097 11.3333L8.0118 16.4167L2.3468 11.3333H6.09097ZM12.1276 11.3333L10.0001 16.9642L7.87263 11.3333H12.1276ZM7.89764 9.66667L8.89764 7.16667H11.1026L12.1026 9.66667H7.89764ZM13.9093 11.3333H17.6518L11.9851 16.4167L13.9093 11.3333ZM16.4926 7.5075L18.0768 9.66667H13.8976L12.8976 7.16667H15.8218C15.9528 7.16662 16.082 7.19746 16.1988 7.25668C16.3156 7.3159 16.4169 7.40183 16.4943 7.5075H16.4926ZM3.5043 7.5075C3.58189 7.4016 3.68339 7.31553 3.80055 7.2563C3.9177 7.19707 4.04719 7.16636 4.17847 7.16667H7.10263L6.10263 9.66667H1.92347L3.5043 7.5075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 0.499992H9.16675V3.83333H10.8334V0.499992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1307 0.974677L13.4642 3.59389L14.8709 4.48889L16.5374 1.86968L15.1307 0.974677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86971 0.981959L3.46375 1.87697L5.13025 4.49488L6.53622 3.59987L4.86971 0.981959Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4032_246521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.9c40e2dc62d997f38c42f75904715de6.svg";
export { ForwardRef as ReactComponent };